module.exports = __webpack_public_path__ + "media/images/riders/small/BAPTISTE_PIERRON-51947464fa8691e5b39bec62382a1bba.png";